import api from './api-config';


export const getBankBalanceSummary = async () => {
    try {
        const response = await api.get('/banks/balance-summary', {});
        return response.data;
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};
